// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"n0-z","subtitle":"o0-z","wrapper":"p0-z","leftArrow":"q0-z","rightArrow":"r0-z"};